import styled from 'styled-components';
import { LinkButton, NavLink, media } from '@minerva-analytics/pantheon';

const SubmitButton = styled(LinkButton)`
  ${media.phone`
    margin-top: 1.5rem;
  `}
`;

const QuestionText = styled.h3`
  max-width: 500px;
  margin-bottom: 10px;
  ${media.phone`
    margin-bottom: 1.5rem;
  `}
`;

const SkipLink = styled(NavLink)`
  display: block;
  margin-top: 2rem;
`;

export {
  SkipLink,
  SubmitButton,
  QuestionText,
};

